<template>
  <div>
    <form @submit.prevent="submit">
      <div class="form-group form-row">
        <div class="col-6">
          <FloatingLabel
            type="text"
            input-class="form-control form-control-xl bg-white border-blue-br"
            label="Nome"
            v-model="firstName"
            v-on:blur="checkName"
          />
          <small class="form-text text-danger" v-if="nameMessage">{{
            nameMessage
          }}</small>
        </div>

        <div class="col-6">
          <FloatingLabel
            type="text"
            input-class="form-control form-control-xl bg-white border-blue-br"
            label="Sobrenome"
            v-model="lastName"
          />
        </div>
      </div>

      <div class="form-group">
        <FloatingLabel
          type="email"
          input-class="form-control form-control-xl bg-white border-blue-br"
          label="E-mail"
          v-model="email"
          v-on:blur="checkEmail.length > 0 && checkEmailConfirm()"
        />
        <small class="form-text text-danger" v-if="emailMessage">{{
          emailMessage
        }}</small>
      </div>

      <div class="form-group">
        <FloatingLabel
          type="email"
          input-class="form-control form-control-xl bg-white border-blue-br"
          label="Repita seu e-mail"
          v-model="emailConfirm"
          v-on:blur="checkEmailConfirm"
        />
        <small class="form-text text-danger" v-if="emailConfirmMessage">{{
          emailConfirmMessage
        }}</small>
      </div>

      <div
        class="form-group"
        v-show="!$store.state.deviseTrying.hasOwnProperty('isForeign')"
      >
        <div class="custom-control custom-checkbox">
          <input
            type="checkbox"
            class="custom-control-input"
            id="foreign"
            v-model="isForeign"
          />
          <label class="custom-control-label" for="foreign"
            >Sou estrangeiro</label
          >
        </div>
      </div>

      <div
        class="form-group"
        v-show="!$store.state.deviseTrying.hasOwnProperty('document')"
      >
        <input
          v-if="!isForeign"
          type="text"
          class="form-control form-control-xl bg-white border-blue-br"
          placeholder="CPF"
          required
          v-model="document"
          @blur="checkDocument"
          v-mask="'###.###.###-##'"
        />
        <input
          v-if="isForeign"
          type="text"
          class="form-control form-control-xl bg-white border-blue-br"
          placeholder="RNE"
          required
          v-model="document"
          @blur="checkDocument"
          v-mask="'XXXXXXXXXXXXXXXXXXXXXXXXXXXX'"
        />

        <small class="form-text text-danger" v-if="documentMessage">{{
          documentMessage
        }}</small>
      </div>

      <div class="form-group form-row">
        <div class="col-6">
          <FloatingLabel
            type="password"
            input-class="form-control form-control-xl bg-white border-blue-br"
            label="Senha"
            v-b-tooltip.focus="'Sua senha deve ter no mínimo 8 caracteres'"
            v-model="password"
            v-on:blur="passwordConfirm.length > 0 && checkPasswordConfirm()"
          />
        </div>

        <div class="col-6">
          <FloatingLabel
            type="password"
            input-class="form-control form-control-xl bg-white border-blue-br"
            label="Repita sua senha"
            v-model="passwordConfirm"
            v-on:blur="checkPasswordConfirm"
          />
          <small class="form-text text-danger" v-if="passwordConfirmMessage">{{
            passwordConfirmMessage
          }}</small>
        </div>
      </div>
      <!-- 
      <vue-recaptcha class="d-flex justify-content-center" sitekey="6LexzmQUAAAAACSwQGT6QOH_1yrY7xYdkvnG9Dvj" @verify="recaptchaVerify" @expired="recaptchaExpired"></vue-recaptcha> -->

      <p class="text-muted mt-5 mb-3 text-center semi-small">
        Ao continuar, você concorda com a coleta e uso de dados pessoais para
        fins exclusivos de recrutamento e seleção.
      </p>

      <div class="text-center mt-3">
        <a
          href="#"
          class="text-black-50 font-weight-bold mr-3"
          @click.prevent="$emit('changeModal', 'login')"
          >Voltar para Login</a
        >
        <button
          type="submit"
          class="btn btn-blue-ml px-4"
          :disabled="!canSubmit"
        >
          Cadastrar meu currículo
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import FloatingLabel from "@/components/FloatingLabel";

export default {
  name: "RegisterForm",

  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      emailConfirm: "",
      isForeign: this.$store.state.deviseTrying.isForeign || false,
      document: this.$store.state.deviseTrying.document || "",
      password: "",
      passwordConfirm: "",

      recaptchaChecked: false,

      nameMessage: null,
      emailMessage: null,
      documentMessage: null,
      passwordConfirmMessage: null,
      emailConfirmMessage: null,
    };
  },

  computed: {
    canSubmit() {
      return (
        this.firstName.length > 2 &&
        this.lastName.length > 2 &&
        this.$helpers.isEmail(this.email) &&
        ((this.isForeign && this.document.length > 5) ||
          (!this.isForeign && this.$helpers.isCPF(this.document))) &&
        this.$helpers.validPassword(this.password) &&
        this.email == this.emailConfirm &&
        this.password == this.passwordConfirm
      );
      //&& this.recaptchaChecked
    },
  },

  components: {
    VueRecaptcha,
    FloatingLabel,
  },

  watch: {
    // Limpa documento quando muda a flag de estrangeiro
    isForeign: function (newValue, oldValue) {
      this.document = "";
      this.documentMessage = null;
    },
  },

  methods: {
    checkName() {
      this.nameMessage = this.firstName.length > 2 ? null : "Nome muito curto";
    },

    checkEmail() {
      this.emailMessage = this.$helpers.isEmail(this.email)
        ? null
        : "E-mail inválido";
    },

    checkEmailConfirm(){
        this.emailConfirmMessage = this.email == this.emailConfirm ? null : 'E-mails diferentes';
      },

    checkDocument() {
      if (!this.isForeign) {
        this.documentMessage = this.$helpers.isCPF(this.document)
          ? null
          : "CPF inválido";
      } else {
        this.documentMessage = this.document.length > 5 ? null : "RNE inválido";
      }
    },

    checkPasswordConfirm() {
      this.passwordConfirmMessage =
        this.password == this.passwordConfirm ? null : "Senhas diferentes";
    },

    recaptchaVerify() {
      this.recaptchaChecked = true;
    },

    recaptchaExpired() {
      this.recaptchaChecked = false;
    },

    submit() {
      let current_profile = this.$store.state.deviseTrying;
      current_profile.first_name = this.firstName;
      current_profile.last_name = this.lastName;
      current_profile.email = this.email;
      current_profile.isForeign = this.isForeign;
      current_profile.document = this.document;
      current_profile.password = this.password;
      current_profile.provider = null;
      current_profile.id = null;
      this.$store.commit("DEVISE_TRYING", current_profile);

      window.signUp = true;

      this.$emit("signUp");
    },
  },
};
</script>

<style lang="scss"></style>